// Снимок бронирования из рассылки BookingChannel старее карточки: обе метки updated_at читаются и снимок строго раньше.
// Отложенный BroadcastBookingJob кладёт в канал состояние на момент выполнения, а SolidCable может отдать его
// подписке уже после загрузки свежей карточки (перезагрузка страницы) — такой снимок откатил бы карточку назад.
// Равные метки — не старее: платёж меняет counts, не трогая updated_at бронирования.
export function isStaleBookingSnapshot(incoming, current) {
  const incomingAt = Date.parse(incoming && incoming.updated_at);
  const currentAt = Date.parse(current && current.updated_at);
  return Number.isFinite(incomingAt) && Number.isFinite(currentAt) && incomingAt < currentAt;
}
